import { Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import * as React from 'react';
import { useEasyBrowserContext } from '../browser';
import ItemTask from './itemtask';
import MenuPrincipalTaskBar from './menuprincipal/menuprincipaltaskbar';
import UsuarioMenu from './menusuario';
import { ToastContainer } from 'react-toastify';
import { ZindexUtils } from '../../../utils/zindexutils';
import FindTaskBar from './findtaskbar';



const TaskBar = React.forwardRef((_props: unknown, _ref: React.ForwardedRef<any>) => {

  const { listaTasks } = useEasyBrowserContext()!;



  return (

    <AppBar position="static"
      className='no-print'
      sx={{
        display: 'flex',
        bgcolor: 'var(--cor-suave)',
        color: 'var(--color-primary)',
        height: '40px',
        margin: '0',
        justifyContent: 'center'


      }}>
      <Toolbar sx={{
        zIndex: ZindexUtils.zIndexBar(), px: {
          sm: '5px',
        },
      }}>

        <MenuPrincipalTaskBar />

        <Box
          className="gestao-scroll-minimo"
          sx={{
            display: 'flex',
            gap: '5px',
            bgcolor: 'transparent',
            overflowY: 'hidden',
            flexGrow: 1,
            overflowX: 'scroll',
            width: "calc(100% - 250px)"
          }}>
          {
            listaTasks.filter(item => item.id !== "easy.schedule.menu.principal").map((item, index) => (
              <ItemTask itemMenu={item} />
            ))
          }
        </Box>
        <FindTaskBar />
        <UsuarioMenu />
      </Toolbar>

    </AppBar>

  );
});


export default TaskBar;